<section>
  <div class="top-panel">
    <span class="top-panel titles">{{title}}</span>
  </div>
  <gen-dynamic-form-table
    [itemTitle]="itemTitle"
    [data]="tableData"
    [formId]="formName"
    [formVertical]="false"
    [tableVertical]="true"
    [viewAsTable]="true"
    [itemRequiredMessage]="'Required information missing'"
    [editMode]="true"
    [popupMode]="true"
    [showDeleteButton]="true"
    [showAddButton]="true"
    [prioritizeAvailable]="prioritizeAvailable"
    [schema]="schema"
    [listenToDataChange]="true"
    [updatedFieldsContextRef]="updatedItemFieldsContextRef"
    [itemValidationEventRef]="itemValidationEventRef"
    (itemDeletedEmitter)="deleteItem($event)"
    (itemAddEmitter)="addNewItem($event)"
    (itemCloneEmitter)="cloneItem($event)"
    (itemUpdateEmitter)="updateContainedData($event)"
    [prioritizeTrackByField]="prioritizeTrackByField"
    [listenToFormConfigChanges]="true"
    [itemNgClassRef]="getCurationItemNgClass.bind(this)"
    [removeItemOnDeleteRef]="shouldRemoveItemOnDelete"
    [isItemDisabledRef]="isItemDisabled.bind(this)"
    [isItemEditModeRef]="isItemEditMode.bind(this)"
    [itemUpdateOnBlurRef]="itemUpdateOnBlur"
    [itemOverridesRef]="itemOverrides"
    [submitted] = "submitted"
    [canDeleteItemRef]="isItemDeletable.bind(this)"
    [disabled]="isReadOnlyMode.bind(this)()"
    [flagDiffFieldsOnUpdate]="flagDiffFieldsOnUpdate"
    [cloneAvailable]="cloneAvailable"
    [applyClone]="applyClone"
    [addButtonText] = "'Add'"
    [addButtonPlacement] = "'UPPER_RIGHT'"
  ></gen-dynamic-form-table>

</section>
